import messages from './tag-messages.js';
export default [
    {tag: 'animation', intlLabel: messages.animation},
    {tag: 'art', intlLabel: messages.art},
    {tag: 'music', intlLabel: messages.music},
    {tag: 'games', intlLabel: messages.games},
    {tag: 'stories', intlLabel: messages.stories}
];
